<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <validation-observer ref="customerDocumentDetailForm">
        <b-form ref="customerDocumentDetailFormElement" class="" @submit.prevent="submit">
          <b-row>
            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Document Type') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="t('Document Type')"
                  rules="required"
                >
                  <b-form-select
                    id="document_type"
                    v-model="values.documentType"
                    name="document_type"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Document Type')"
                    tabindex="3"
                    :options="documentTypesOption"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Status') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Status')" rules="required">
                  <b-form-select
                    id="status"
                    v-model="values.status"
                    name="status"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Status')"
                    tabindex="3"
                    :options="statusOptions"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                variant="primary"
                class="mt-1 d-flex align-items-center"
                type="submit"
                tabindex="11"
              >
                {{
                  submitting ? t('Please Wait') : type === 'new' ? t('Add New Document') : t('Edit')
                }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>
<script>
import { BCol, BForm, BFormGroup, BRow, BFormSelect, BButton, BOverlay } from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper';

export default {
  components: {
    BOverlay,
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BForm,
    BFormSelect,

    ValidationObserver,
    ValidationProvider
  },

  mixins: [helper],
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          documentType: '',
          status: ''
        };
      }
    }
  },
  data() {
    return {
      statusTypeOptions: [],
      documentTypes: []
    };
  },

  computed: {
    documentTypesOption() {
      const options = [{ text: this.$t('Make a Choice'), value: '' }];
      if (this.documentTypes && this.documentTypes.length > 0) {
        options.push(
          ...this.documentTypes.map(item => ({
            text: item.info,
            value: item.value
          }))
        );
      }
      return options;
    },

    statusOptions() {
      const options = [{ text: this.$t('Make a Choice'), value: '' }];
      if (this.statusTypeOptions && this.statusTypeOptions.length > 0) {
        options.push(
          ...this.statusTypeOptions.map(item => ({
            text: item.info,
            value: item.value
          }))
        );
      }
      return options;
    }
  },

  async created() {
    this.documentTypes = await this.getCustomerDocumentType();
    this.statusTypeOptions = await this.getProviderAdditionalFeeStatus();
  },

  methods: {
    submit() {
      this.$refs.customerDocumentDetailForm.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values
          });
        }
      });
    },

    resetForm() {
      this.$refs.customerDocumentDetailFormElement.reset();
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
